export default class User {
    company: string;
    username: string;

    constructor(company: string, username: string) {
        this.company = company;
        this.username = username;
    }
}
